const crossfadeDurationMs = 125;
const actions = "_35saqwbqa2";
const crossfadeWrapper = "_35scm61nwq";
const crossfadeContainer = "_35sc1x8sqsl";
const prevButton = "_35sp724vub";
const nextButton = "_35sn1dmb8ip";

export { actions, crossfadeContainer, crossfadeDurationMs, crossfadeWrapper, nextButton, prevButton };
import "./_actions.style.linaria.module.css";
//# sourceMappingURL=_actions.style.js.map
